import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetailNew from './pages/ProductDetailNew';
import About from './pages/About';
import Contact from './pages/Contact';
import Checkout from './pages/Checkout';
import CheckoutNew from './pages/CheckoutNew';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Register from './pages/Register';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Success from './pages/Success';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { analytics } from './lib/posthog';

// Component to track page views
function PageViewTracker() {
  const location = useLocation();
  
  useEffect(() => {
    analytics.pageView(location.pathname);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Header />
            <PageViewTracker />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/produtos" element={<Products />} />
                <Route path="/produkte" element={<Products />} />
                <Route path="/product/:id" element={<ProductDetailNew />} />
                <Route path="/produto/:id" element={<ProductDetailNew />} />
                <Route path="/producto/:id" element={<ProductDetailNew />} />
                <Route path="/produkt/:id" element={<ProductDetailNew />} />
                <Route path="/about" element={<About />} />
                <Route path="/sobre" element={<About />} />
                <Route path="/uber-uns" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/contato" element={<Contact />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/kontakt" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/carrinho" element={<Cart />} />
                <Route path="/carrito" element={<Cart />} />
                <Route path="/warenkorb" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout-new" element={<CheckoutNew />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/registro" element={<Register />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/success" element={<Success />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
